module.exports = __webpack_public_path__ + "static/media/15-KebabBowl.dcf338c7.png";